import { render, staticRenderFns } from "./FigmaImageLayer.vue?vue&type=template&id=b35d88f2&scoped=true"
import script from "./FigmaImageLayer.vue?vue&type=script&lang=js"
export * from "./FigmaImageLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35d88f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b35d88f2')) {
      api.createRecord('b35d88f2', component.options)
    } else {
      api.reload('b35d88f2', component.options)
    }
    module.hot.accept("./FigmaImageLayer.vue?vue&type=template&id=b35d88f2&scoped=true", function () {
      api.rerender('b35d88f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/figma-layers/layers/FigmaImageLayer.vue"
export default component.exports